import {
    LOADING_TOGGLE_ACTION,
    LOGIN_CONFIRMED_ACTION,
    LOGIN_FAILED_ACTION,
    LOGOUT_ACTION,
    SIGNUP_CONFIRMED_ACTION,
    SIGNUP_FAILED_ACTION,
} from "../actions/AuthActions";

const initialState = {
    token: null,        // 👈 AUTH FLAG
    user: null,         // 👈 FULL USER PROFILE
    errorMessage: "",
    successMessage: "",
    showLoading: false,
};

export function AuthReducer(state = initialState, action) {
    switch (action.type) {

        case SIGNUP_CONFIRMED_ACTION:
            return {
                ...state,
                token: action.payload.token || null,
                user: action.payload,
                errorMessage: "",
                successMessage: "Signup Successfully Completed",
                showLoading: false,
            };

        case LOGIN_CONFIRMED_ACTION:
            return {
                ...state,
                token: action.payload.token,   // ✅ IMPORTANT
                user: action.payload,
                errorMessage: "",
                successMessage: "Login Successfully Completed",
                showLoading: false,
            };

        case LOGOUT_ACTION:
            return {
                ...state,
                token: null,
                user: null,
                errorMessage: "",
                successMessage: "",
            };

        case SIGNUP_FAILED_ACTION:
        case LOGIN_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: "",
                showLoading: false,
            };

        case LOADING_TOGGLE_ACTION:
            return {
                ...state,
                showLoading: action.payload,
            };

        default:
            return state;
    }
}
